import { AxiosError } from 'axios'

import { api } from '../libs/axios'

interface UserBase {
  id: string
  name: string
  phone: string
  email: string
  avatar_url: string
}

export interface PromotersCompany {
  id: string
  name: string
  document: string
  managers: UserBase[]
  promoters: UserBase[]
  created_at: string
}

export interface GetPromotersCompaniesRequest {
  page?: number
  id?: string
  name?: string
  document?: string
  manager_id?: string
  promoter_id?: string
}

interface GetPromotersCompaniesResponse {
  promotersCompanies: PromotersCompany[]
  totalCount: number
  pageQty: number
}

export async function getPromotersCompanies(
  searchParams: GetPromotersCompaniesRequest,
): Promise<GetPromotersCompaniesResponse> {
  try {
    const params: { [key: string]: string | boolean } = {}

    Object.entries(searchParams).forEach(([key, value]) => {
      const param = key.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase()
      params[param] = value
    })

    const result = await api.get<GetPromotersCompaniesResponse>('/promoters-company', {
      params,
    })

    const { data } = result

    return data
  } catch (err) {
    if (err instanceof AxiosError) {
      console.error(err.message)
    }
    return {
      promotersCompanies: [],
      pageQty: 0,
      totalCount: 0,
    }
  }
}

interface CreatePromotersCompanyRequest {
  name: string
  document: string
}

interface CreatePromotersCompanyResponse {
  promotersCompany: PromotersCompany
}

export async function createPromotersCompany({
  name,
  document,
}: CreatePromotersCompanyRequest) {
  try {
    const { data } = await api.post<CreatePromotersCompanyResponse>('/promoters-company', {
      name,
      document,
    })

    return {
      promotersCompany: data.promotersCompany,
      success: true,
      message: 'Empresa de promotores atualizada',
    }
  } catch (err) {
    if (err instanceof AxiosError) {
      return {
        promotersCompany: undefined,
        success: false,
        message: err.response?.data.message ?? 'Não foi possível atualizar empresa de promomotores!',
      }
    }
  }
}

interface UpdatePromotersCompanyRequest {
  name?: string
  document?: string
  promotersCompanyId: string
}

interface UpdatePromotersCompanyResponse {
  promotersCompany: PromotersCompany
}

export async function updatePromotersCompany({
  name,
  document,
  promotersCompanyId,
}: UpdatePromotersCompanyRequest) {
  try {
    const { data } = await api.put<UpdatePromotersCompanyResponse>(`/promoters-company/${promotersCompanyId}`, {
      name,
      document,
    })

    return {
      promotersCompany: data.promotersCompany,
      success: true,
      message: 'Empresa de promotores criada',
    }
  } catch (err) {
    if (err instanceof AxiosError) {
      return {
        promotersCompany: undefined,
        success: false,
        message: err.response?.data.message ?? 'Não foi possível criar empresa de promomotores!',
      }
    }
  }
}

interface GetAllPromotersCompaniesResponse {
  promotersCompanies: {
    id: string
    name: string
  }[]
}

export async function getAllPromotersCompanies() {
  const { data } = await api.get<GetAllPromotersCompaniesResponse>('/promoters-company/all')

  return data ?? []
}
